// Payment Store

const state = {
  paymentServices: [],
  pending: false,
  pendingData: false,
  dataErrors: {},
  activePaymentService: null,
}

const getters = {
  isPending: ({ pending }) => pending,
}

const actions = {
  getPaymentServices({ commit }) {
    return new Promise(resolve => {
      commit('SET_PENDING')
      this.api.items.getItems('payments').then(({ data }) => {
        const services = data.services.filter(service => window.applePayActive || service.pt !== 17)
        commit('SET_PAYMENT_SERVICES', services)
        commit('SET_PENDING')
        resolve()
      })
    })
  },
  updatePaymentService({ commit }, payload) {
    return new Promise(resolve => {
      commit('SET_PENDING')
      this.api.items.createItem('carts.mine.payment', { payment: payload }).then(_ => {
        commit('SET_ACTIVE_SERVICE', payload)
        commit('SET_PENDING')
        resolve()
      })
    })
  },
  updatePaymentData({ commit }, payload) {
    return new Promise((resolve, reject) => {
      commit('SET_PENDING_DATA')
      this.api.items.createItem('carts.mine.payment', { ...payload }).then(_ => {
        commit('SET_PENDING_DATA')
        commit('CLEAR_DATA_ERROR')
        resolve()
      }).catch(({ data }) => {
        commit('SET_PENDING_DATA')
        commit('SET_DATA_ERROR', data.errors)
      })
    })
  },
}

const mutations = {
  SET_PENDING: state => {
    state.pending = !state.pending
  },
  SET_PENDING_DATA: state => {
    state.pendingData = !state.pendingData
  },
  CLEAR_DATA_ERROR: state => {
    state.dataErrors = {}
  },
  SET_DATA_ERROR: (state, errors) => {
    state.dataErrors = errors
  },
  SET_PAYMENT_SERVICES: (state, payload) => {
    state.paymentServices = payload
  },
  SET_ACTIVE_SERVICE: (state, payload) => {
    state.activePaymentService = payload
  },
  INIT_ACTIVE_SERVICE: (state, payload) => {
    state.activePaymentService = payload
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
